// extracted by mini-css-extract-plugin
export default {"Servicedetails":"service-details_Servicedetails__FP7R8"};